import {Injectable} from '@angular/core';
import {HttpClient} from "./http.client";

@Injectable()
export class AuthService {

    constructor(private _http: HttpClient) {
    }

    getUserDetails() {
        return this._http.get("/user/getDetails");
    }

    signOut() {
        return this._http
            .post("/authentication/signOut", null);
    }

    signIn(email: string, password: string) {
        return this._http.post("/authentication/signIn", {
            email: email,
            password: password
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts